<template>
    <div id="order-package-modal">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-12"><h4 class="smalltitle">Choose Order Package for {{clinic.fullName}}</h4></div>
                </div>
            </div>
            <div class="block-body">
                <div class="prolabel note">Choose a service</div>
                <div class="profield"><span class="selectwrap">
                    <select v-model="dataInfo.serviceId">
                        <option value="">Choose a service</option>
                        <option :key="service._id" v-for="(service) in listServices" :value="service._id">
                            {{ service.title }}
                        </option>
                    </select>
                </span>
                </div>

              <div class="prolabel note">Choose a package</div>
              <div class="profield">
<!--                <span class="selectwrap">-->
<!--                    <select v-model="dataInfo.packageId">-->
<!--                        <option value="">Choose a package</option>-->
<!--                        <option :key="`package-${indexPackage}`" v-for="(service, indexPackage) in listPackages" :value="service._id">-->
<!--                            {{ service.name }}-->
<!--                        </option>-->
<!--                      -->
<!--                      -->
<!--                    </select>-->

<!--                </span>-->
                <multi-select v-model="dataInfo.listPackageId"
                              :filterable="true" :options="listPackages"
                              class="multi-select-block"
                              selected-icon=""
                              style="width: 100%"
                ></multi-select>
              </div>
            </div>
            <div slot="footer">
                <button type="button" class="btn btn-default" @click="addService">
                  <i class="fas fa-spinner fa-spin" v-if="isProcessing"></i> {{isEdit ? 'Update' : 'Create'}}
                </button>
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>

    </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'OrderPackageModal',
  components: {},
  props: {
    clinic: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      isLoading: true,
      listServices: [],
      listPackages: [],
      dataInfo: {
        serviceId: '',
        packageId: '',
        listPackageId: []
      },
      isProcessing: false,
      clinicOrderPackage: null
    }
  },
  computed: {
    isEdit () {
      return this.clinicOrderPackage
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getDataService()
  },
  beforeDestroy () {
  },
  methods: {
    async addService () {
      if (this.isProcessing) {
        return
      }
      try {
        let response = await httpClient.post(`/clinic/add-service`, {
          clinicId: this.clinic.id,
          serviceId: this.dataInfo.serviceId,
          packageId: this.dataInfo.packageId,
          listPackageId: this.dataInfo.listPackageId
        })
        if (response.data.s === 200) {
          this.alertSuccess(response.data.msg)
          this.modal = false
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        console.log(e.message)
        this.alertError('Server error.Try again later')
      }
    },
    async getDataService () {
      try {
        let params = { clinicId: this.clinic.id }
        let response = await httpClient.get(`/clinic/init-order-package`, { params: params })
        this.isLoading = false
        if (response.data.s === 200) {
          this.listServices = response.data.data.services
          const packages = response.data.data.packages
          this.listPackages = []
          packages.forEach(item => {
            this.listPackages.push({ label: item.name, value: item._id })
          })
          this.clinicOrderPackage = response.data.data.clinicOrderPackage
          if (this.clinicOrderPackage) {
            this.dataInfo.serviceId = this.clinicOrderPackage.serviceId ? this.clinicOrderPackage.serviceId : ''
            let listPackageIds = this.clinicOrderPackage.listPackageId ? this.clinicOrderPackage.listPackageId : []
            if(listPackageIds) {
              this.dataInfo.listPackageId = []
              listPackageIds.forEach(packageId => {
                const index = this.listPackages.findIndex(item => item.value === packageId)
                if(index > 0) {
                  this.dataInfo.listPackageId.push(packageId)
                }
              })
            }
          }
        }
      } catch (e) {
        console.log(e.message)
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style>
#order-package-modal .multi-select-block .dropdown-toggle {
  border-radius: 0px !important;
}
#order-package-modal .multi-select-block > .form-control {
  padding: 8px 10px;
  border-radius: 0px !important;
}
</style>
</style>
<style scoped="">
    .item-file-name {
        display: inline-block;
        max-width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 5px;
    }

    .item-name {
        width: 50% !important;
        cursor: pointer;
        min-height: 1px;
    }

    .item-kind {
        width: 20% !important;
        min-height: 1px;

    }

    .item-status {
        width: 30% !important;
        min-height: 1px;
    }

    .item-action {
        width: 10% !important;
        text-align: right;
        padding-right: 10px;
        float: right;
    }
